import React, { useState, useEffect, useRef } from 'react';
import {
    Table, Card, Form, Input, Select, DatePicker, Button, Space, Tag,
    Typography, Drawer, Descriptions, Empty, Tabs, Cascader
} from 'antd';
import {
    SearchOutlined, ReloadOutlined, ArrowLeftOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { getExtraPlatformLogs, getExtraEnterpriseLogs } from '../../utils/auditLogStore';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

// TODO: 联调时替换为接口数据

// ══════════════════════════════════════════════
//  Mock 数据
// ══════════════════════════════════════════════

// 平台内部操作日志
const MOCK_PLATFORM_LOGS = [
    // ═══ 企业审核 ═══
    { key: 'p1', time: '2026-05-21 16:30:00', operatorName: '李审核', operatorAccount: 'li_audit', ip: '192.168.1.101', module: '企业管理 > 平台客户', opType: '状态变更', target: '深圳智创科技有限公司\nENT001', summary: '审核通过企业注册申请，分配角色：产品方案商、设备制造商', detail: { before: { status: '待审核' }, after: { status: '已认证', roles: ['产品方案商', '设备制造商'] } } },
    { key: 'p2', time: '2026-05-21 14:20:00', operatorName: '李审核', operatorAccount: 'li_audit', ip: '192.168.1.101', module: '企业管理 > 平台客户', opType: '状态变更', target: '广州迅捷科技有限公司\nENT006', summary: '审核驳回企业注册申请，原因：营业执照已过期，统一社会信用代码与工商信息不一致', detail: { before: { status: '待审核' }, after: { status: '未通过', rejectReason: '营业执照已过期，统一社会信用代码与工商信息不一致' } } },
    { key: 'p3', time: '2026-05-20 09:15:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '企业管理 > 平台客户', opType: '创建', target: '成都云视科技有限公司\nENT005', summary: '平台直接创建企业：企业角色"应用服务商"，自动生成管理员账号 chengdu_cloud_admin', detail: { before: null, after: { name: '成都云视科技有限公司', role: '应用服务商', account: 'chengdu_cloud_admin', status: '已认证' } } },
    // ═══ 产品审核与配置 ═══
    { key: 'p4', time: '2026-05-21 16:55:00', operatorName: '李审核', operatorAccount: 'li_audit', ip: '192.168.1.101', module: '产品管理 > 产品审核', opType: '状态变更', target: '智能摄像头 Pro\nPID-4821', summary: '审核通过产品发布申请，自动赠送测试授权 10 个、生产授权 0 个', detail: { before: { status: '发布中' }, after: { status: '已发布', testAuth: 10, productionAuth: 0 } } },
    { key: 'p5', time: '2026-05-20 11:40:00', operatorName: '李审核', operatorAccount: 'li_audit', ip: '192.168.1.101', module: '产品管理 > 产品审核', opType: '状态变更', target: '智能门铃 Lite\nPID-7721', summary: '审核驳回产品发布申请，原因：物模型未配置必要的能力项，请补充"WIFI信号"和"双向语音"后再提交', detail: { before: { status: '发布中' }, after: { status: '发布失败', rejectReason: '物模型未配置必要的能力项：WIFI信号、双向语音' } } },
    { key: 'p6', time: '2026-05-21 17:10:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '产品管理 > 产品审核管理', opType: '配置修改', target: '智能摄像头 Pro\nPID-4821', summary: '设置授权采购定价：生产授权单价 ¥2.50/个', detail: { before: { unitPrice: '未设置' }, after: { unitPrice: '2.50' } } },
    { key: 'p7', time: '2026-05-21 17:12:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '产品管理 > 产品审核管理', opType: '配置修改', target: '智能摄像头 Pro\nPID-4821', summary: '手动赠送授权：向深圳智创科技有限公司赠送生产授权 50 个', detail: { before: null, after: { enterprise: '深圳智创科技有限公司', authType: '生产授权', quantity: 50 } } },
    // ═══ 应用审核 ═══
    { key: 'p8', time: '2026-05-21 15:00:00', operatorName: '李审核', operatorAccount: 'li_audit', ip: '192.168.1.101', module: '应用服务 > 审核应用', opType: '状态变更', target: 'HomeStar\nAPP-001', summary: '审核通过应用 iOS 国内版本，设置运营方式为"企业自运营"', detail: { before: { status: '待审核' }, after: { status: '已通过', operationMode: '企业自运营', platform: 'iOS', region: '中国大陆' } } },
    { key: 'p9', time: '2026-05-20 14:30:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '应用服务 > 审核应用', opType: '配置修改', target: 'HomeStar\nAPP-001', summary: '修改运营方式：Android 国内版从"企业自运营"改为"平台代运营"', detail: { before: { operationMode: '企业自运营' }, after: { operationMode: '平台代运营', platform: 'Android', region: '中国大陆' } } },
    // ═══ 平台账务 ═══
    { key: 'p10', time: '2026-05-21 10:30:00', operatorName: '赵财务', operatorAccount: 'zhao_finance', ip: '192.168.1.102', module: '平台账务 > 抽佣配置', opType: '配置修改', target: '设备制造商抽佣规则', summary: '调整设备制造商抽佣比例：从 5% 下调至 3%，适用范围：全部设备制造商', detail: { before: { commissionRate: '5%', scope: '全部' }, after: { commissionRate: '3%', scope: '全部' } } },
    { key: 'p11', time: '2026-05-21 09:00:00', operatorName: '赵财务', operatorAccount: 'zhao_finance', ip: '192.168.1.102', module: '平台账务 > 汇率管理', opType: '配置修改', target: '美元汇率', summary: '调整美元兑人民币汇率：7.25 → 7.18', detail: { before: { usdRate: '7.25' }, after: { usdRate: '7.18' } } },
    { key: 'p12', time: '2026-05-20 16:00:00', operatorName: '赵财务', operatorAccount: 'zhao_finance', ip: '192.168.1.102', module: '平台账务 > 信用额度', opType: '配置修改', target: '杭州万物互联有限公司\nENT002', summary: '调整企业信用额度：¥50,000 → ¥100,000，原因：企业申请提额并通过资质审核', detail: { before: { creditLimit: '50000' }, after: { creditLimit: '100000', reason: '资质审核通过' } } },
    { key: 'p13', time: '2026-05-20 14:00:00', operatorName: '赵财务', operatorAccount: 'zhao_finance', ip: '192.168.1.102', module: '平台账务 > 提现审核', opType: '状态变更', target: '提现申请\nWD-20260520-008', summary: '审核通过提现申请：企业"北京智联科技有限公司"，金额 ¥28,500.00，打款至企业对公账户', detail: { before: { status: '待审核' }, after: { status: '已打款', enterprise: '北京智联科技有限公司', amount: '28500' } } },
    // ═══ 权限管理 ═══
    { key: 'p14', time: '2026-05-21 08:30:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '权限管理 > 菜单配置', opType: '编辑', target: '内部角色：运营主管\nROLE-PLAT-002', summary: '修改运营主管角色的菜单权限：新增"日志审计"模块访问权限', detail: { before: { menus: ['企业管理', '产品管理', '权限管理', '平台账务'] }, after: { menus: ['企业管理', '产品管理', '权限管理', '平台账务', '日志审计'] } } },
    { key: 'p15', time: '2026-05-19 10:00:00', operatorName: '王运营', operatorAccount: 'wang_admin', ip: '192.168.1.100', module: '权限管理 > 内部账号', opType: '状态变更', target: '内部账号：liu_audit\n刘审核', summary: '停用内部账号"liu_audit"，原因：员工离职', detail: { before: { status: '启用' }, after: { status: '停用', reason: '员工离职' } } },
];

// 企业操作日志
const MOCK_ENTERPRISE_LOGS = [
    // ═══ 深圳智创：智能摄像头 Pro 产品开发全流程 ═══
    { key: 'e1', time: '2026-05-20 16:22:10', operatorName: '张三', operatorAccount: 'zhang_admin', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.50', module: '产品管理 > 产品开发', opType: '创建', target: '智能摄像头 Pro\nPID-4821', summary: '创建产品：类目"摄像机 > 室内摄像机 > 云台摄像机Wi-Fi"，联网方式 Wi-Fi，供电方式 DC 5V', detail: { before: null, after: { name: '智能摄像头 Pro', category: '云台摄像机Wi-Fi', network: 'Wi-Fi', power: 'DC 5V' } } },
    { key: 'e2', time: '2026-05-20 16:35:42', operatorName: '张三', operatorAccount: 'zhang_admin', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.50', module: '产品管理 > 产品开发', opType: '编辑', target: '智能摄像头 Pro\nPID-4821', summary: '编辑产品信息：修改产品型号为 HC-Pro-2026，补充产品描述"360°全景云台，AI人形检测，双向语音对讲"', detail: { before: { model: '', description: '' }, after: { model: 'HC-Pro-2026', description: '360°全景云台，AI人形检测，双向语音对讲' } } },
    { key: 'e3', time: '2026-05-20 17:10:05', operatorName: '张三', operatorAccount: 'zhang_admin', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.50', module: '产品管理 > 产品开发', opType: '编辑', target: '智能摄像头 Pro\nPID-4821', summary: '配置物模型：选择能力项"WIFI信号""TF卡读写""云台控制""AI人形检测""双向语音"', detail: { before: { capabilities: [] }, after: { capabilities: ['WIFI信号', 'TF卡读写', '云台控制', 'AI人形检测', '双向语音'] } } },
    { key: 'e4', time: '2026-05-21 09:15:30', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件列表', opType: '创建', target: '主控固件 V1.0.0\nFW-4821', summary: '上传固件：生产固件，SDK 版本 v3.2.1，固件大小 8.5MB', detail: { before: null, after: { fwName: '主控固件', fwVersion: 'V1.0.0', fwType: ['生产固件'], sdk: 'v3.2.1', size: '8.5MB' } } },
    { key: 'e5', time: '2026-05-21 10:02:18', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件详情', opType: '编辑', target: '主控固件 V1.0.0\nFW-4821', summary: '修改固件类型：增加"升级固件"类型，固件同时用于生产烧录和 OTA 升级', detail: { before: { fwType: ['生产固件'] }, after: { fwType: ['生产固件', '升级固件'] } } },
    { key: 'e6', time: '2026-05-21 10:30:45', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件详情', opType: '编辑', target: '主控固件 V1.0.0\nFW-4821', summary: '配置生产测试项：选择"图像测试""WIFI信号""TF卡读写""麦克风测试""喇叭测试""PTZ测试"', detail: { before: { testItems: [] }, after: { testItems: ['图像测试', 'WIFI信号', 'TF卡读写', '麦克风测试', '喇叭测试', 'PTZ测试'] } } },
    { key: 'e7', time: '2026-05-21 11:05:33', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件详情', opType: '创建', target: '测试 License\nA01T012605210001', summary: '生成测试 License：消耗 1 个测试授权余额，用于固件功能测试', detail: { before: null, after: { license: 'A01T012605210001', authType: '测试授权', remainingTestAuth: 9 } } },
    { key: 'e8', time: '2026-05-21 11:20:10', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件详情', opType: '状态变更', target: '主控固件 V1.0.0\nFW-4821', summary: '发起固件功能测试：选择测试设备 License"A01T012605210001"，下发固件到设备', detail: { before: { status: '待测试' }, after: { status: '测试中', testLicense: 'A01T012605210001' } } },
    { key: 'e9', time: '2026-05-21 14:40:55', operatorName: '李四', operatorAccount: 'li_dev', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.51', module: '固件管理 > 固件详情', opType: '状态变更', target: '主控固件 V1.0.0\nFW-4821', summary: '确认固件功能测试通过：App 端验证图像、云台控制、语音对讲功能均正常', detail: { before: { status: '测试中' }, after: { status: '测试通过' } } },
    { key: 'e10', time: '2026-05-21 15:10:22', operatorName: '张三', operatorAccount: 'zhang_admin', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', ip: '10.0.1.50', module: '产品管理 > 产品开发', opType: '状态变更', target: '智能摄像头 Pro\nPID-4821', summary: '发布产品提交平台审核', detail: { before: { status: '可发布' }, after: { status: '发布中' } } },
    // ═══ 杭州万物互联：生产管理 ═══
    { key: 'e11', time: '2026-05-21 08:30:00', operatorName: '王经理', operatorAccount: 'wang_mgr', enterpriseName: '杭州万物互联有限公司', enterpriseId: 'ENT002', ip: '10.0.2.20', module: '生产管理 > 生产工单', opType: '创建', target: '可视门铃 Pro Q3批次\nWO-2026-015', summary: '创建生产工单：产品"可视门铃 Pro"，生产数量 500，选择固件 V2.3.0（测试通过），使用平台产测工具', detail: { before: null, after: { product: '可视门铃 Pro', quantity: 500, fwVersion: 'V2.3.0', mode: '平台产测工具' } } },
    { key: 'e12', time: '2026-05-21 09:45:18', operatorName: '王经理', operatorAccount: 'wang_mgr', enterpriseName: '杭州万物互联有限公司', enterpriseId: 'ENT002', ip: '10.0.2.20', module: '生产管理 > 生产工单', opType: '编辑', target: '可视门铃 Pro Q3批次\nWO-2026-015', summary: '编辑生产工单：增加三方授权文件导入（MAC 地址清单），修改产测分组为"华东生产部"', detail: { before: { testGroup: '默认分组', thirdPartyAuth: '无' }, after: { testGroup: '华东生产部', thirdPartyAuth: '已导入 500 条 MAC 地址' } } },
    { key: 'e13', time: '2026-05-21 16:00:35', operatorName: '王经理', operatorAccount: 'wang_mgr', enterpriseName: '杭州万物互联有限公司', enterpriseId: 'ENT002', ip: '10.0.2.20', module: '设备中心 > 固件 OTA', opType: '创建', target: '可视门铃固件升级\nOTA-2026-022', summary: '创建固件OTA任务：产品"可视门铃 Pro"，目标固件 V2.4.0，静默升级，覆盖已激活设备 320 台', detail: { before: null, after: { product: '可视门铃 Pro', targetVersion: 'V2.4.0', type: '静默升级', deviceCount: 320 } } },
    // ═══ 北京智联：分润与分销 ═══
    { key: 'e14', time: '2026-05-20 15:30:00', operatorName: '赵开发', operatorAccount: 'zhao_dev', enterpriseName: '北京智联科技有限公司', enterpriseId: 'ENT003', ip: '10.0.3.10', module: '分润管理 > App 分润', opType: '创建', target: '智能门铃 Lite\nPID-7721', summary: '创建自动分润配置：产品"智能门铃 Lite"，分润对象"华东分销商"，分润比例 12%', detail: { before: null, after: { product: '智能门铃 Lite', mode: '自动分润', target: '华东分销商', ratio: '12%' } } },
    { key: 'e15', time: '2026-05-20 17:50:12', operatorName: '赵开发', operatorAccount: 'zhao_dev', enterpriseName: '北京智联科技有限公司', enterpriseId: 'ENT003', ip: '10.0.3.10', module: '设备分销 > 我的设备分销', opType: '创建', target: '智能门铃 Lite 2026Q2\nWO-2026-010', summary: '发起设备分销（按批次）：选择生产批次"智能门铃 Lite 2026Q2"，下级企业"华北代理"，设备数 300', detail: { before: null, after: { batch: '智能门铃 Lite 2026Q2', target: '华北代理', deviceCount: 300 } } },
];

// 企业列表（平台视角）
const MOCK_ENTERPRISE_LIST = [
    { key: 'ent1', enterpriseName: '深圳智创科技有限公司', enterpriseId: 'ENT001', logCount: 10 },
    { key: 'ent2', enterpriseName: '杭州万物互联有限公司', enterpriseId: 'ENT002', logCount: 3 },
    { key: 'ent3', enterpriseName: '北京智联科技有限公司', enterpriseId: 'ENT003', logCount: 2 },
    { key: 'ent4', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'ENT004', logCount: 230 },
    { key: 'ent5', enterpriseName: '成都云视科技有限公司', enterpriseId: 'ENT005', logCount: 98 },
];

// ══════════════════════════════════════════════
//  常量
// ══════════════════════════════════════════════

const OP_TYPE_COLORS = {
    '创建': 'blue',
    '编辑': 'orange',
    '删除': 'red',
    '状态变更': 'purple',
    '配置修改': 'cyan',
};

const MODULE_CASCADER_OPTIONS = [
    { value: '产品管理', label: '产品管理', children: [
        { value: '产品管理 > 产品开发', label: '产品开发' },
        { value: '产品管理 > 产品审核', label: '产品审核' },
        { value: '产品管理 > 产品审核管理', label: '产品审核管理' },
    ]},
    { value: '固件管理', label: '固件管理', children: [
        { value: '固件管理 > 固件列表', label: '固件列表' },
        { value: '固件管理 > 固件详情', label: '固件详情' },
    ]},
    { value: '生产管理', label: '生产管理', children: [
        { value: '生产管理 > 生产工单', label: '生产工单' },
        { value: '生产管理 > 产测账号', label: '产测账号' },
    ]},
    { value: '设备中心', label: '设备中心', children: [
        { value: '设备中心 > 固件 OTA', label: '固件 OTA' },
    ]},
    { value: '应用服务', label: '应用服务', children: [
        { value: '应用服务 > 应用管理', label: '应用管理' },
        { value: '应用服务 > 平台商户号', label: '平台商户号' },
        { value: '应用服务 > 企业商户号', label: '企业商户号' },
        { value: '应用服务 > 审核应用', label: '审核应用' },
    ]},
    { value: '设备分销', label: '设备分销', children: [
        { value: '设备分销 > 我的设备分销', label: '我的设备分销' },
        { value: '设备分销 > 代理设备分销', label: '代理设备分销' },
    ]},
    { value: '分润管理', label: '分润管理', children: [
        { value: '分润管理 > App 分润', label: 'App 分润' },
        { value: '分润管理 > 分润再分配', label: '分润再分配' },
        { value: '分润管理 > 分润支出', label: '分润支出' },
    ]},
    { value: '企业管理', label: '企业管理', children: [
        { value: '企业管理 > 平台客户', label: '平台客户' },
    ]},
    { value: '平台账务', label: '平台账务', children: [
        { value: '平台账务 > 抽佣配置', label: '抽佣配置' },
        { value: '平台账务 > 提现审核', label: '提现审核' },
    ]},
    { value: '权限管理', label: '权限管理', children: [
        { value: '权限管理 > 菜单配置', label: '菜单配置' },
    ]},
    { value: '客户跟踪', label: '客户跟踪', children: [
        { value: '客户跟踪 > 出货计划', label: '出货计划' },
        { value: '客户跟踪 > 服务排期', label: '服务排期' },
    ]},
    { value: '客服工具', label: '客服工具', children: [
        { value: '客服工具 > 出货计划', label: '出货计划' },
        { value: '客服工具 > 服务排期', label: '服务排期' },
    ]},
];

const LABEL_MAP = {
    // 通用
    name: '名称', status: '状态', type: '类型', reason: '原因',
    // 企业
    roles: '企业角色', rejectReason: '驳回原因', account: '管理员账号',
    // 产品
    category: '产品类目', network: '联网方式', power: '供电方式',
    model: '产品型号', description: '产品描述', capabilities: '能力项',
    unitPrice: '授权单价', enterprise: '所属企业', authType: '授权类型',
    testAuth: '赠送测试授权', productionAuth: '赠送生产授权',
    // 固件
    fwName: '固件名称', fwVersion: '固件版本', fwType: '固件类型',
    sdk: 'SDK版本', size: '固件大小', testItems: '生产测试项',
    license: 'License', remainingTestAuth: '剩余测试授权', testLicense: '测试设备',
    // 生产
    product: '产品', quantity: '数量', batch: '生产批次',
    testGroup: '产测分组', thirdPartyAuth: '三方授权',
    // OTA
    targetVersion: '目标版本', deviceCount: '设备数量',
    // 应用
    operationMode: '运营方式', platform: '平台终端', region: '上架区域',
    // 账务
    commissionRate: '抽佣比例', usdRate: '美元汇率', creditLimit: '信用额度',
    amount: '金额', scope: '适用范围', feeRate: '费率',
    // 分润与分销
    target: '分润对象', ratio: '分润比例', mode: '分润模式',
    // 权限
    menus: '菜单权限', role: '角色',
    // 客户跟踪（出货计划 / 服务排期）
    targetMarket: '下游/目标市场', planDate: '计划出货时间', actualDate: '实际出货时间',
    logistics: '物流信息', remark: '备注',
    content: '服务内容', start: '开始时间', end: '结束时间', milestone: '里程碑',
};

// ══════════════════════════════════════════════
//  子组件：日志列表筛选区
// ══════════════════════════════════════════════

const LogFilter = ({ isPlatformTab, showEnterpriseFilter, filterState, setFilterState, onSearch, onReset }) => {
    const { filterModule, filterOperator, filterOpType, filterDateRange, filterKeyword, filterEnterprise } = filterState;

    return (
        <Card bordered={false} style={{ marginBottom: 12, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <Form layout="inline" style={{ flexWrap: 'wrap', gap: 0 }}>
                <Form.Item style={{ marginBottom: 12 }}>
                    <Cascader
                        multiple
                        allowClear
                        showSearch
                        placeholder="操作模块"
                        style={{ width: 220 }}
                        value={filterModule}
                        onChange={(v) => setFilterState(s => ({ ...s, filterModule: v || [] }))}
                        options={MODULE_CASCADER_OPTIONS}
                        maxTagCount={2}
                        changeOnSelect
                        expandTrigger="hover"
                        tagRender={({ label, onClose }) => {
                            // 展示为"模块 > 菜单"格式
                            const text = Array.isArray(label) ? label.join(' > ') : label;
                            return <Tag closable onClose={onClose} style={{ marginRight: 3 }}>{text}</Tag>;
                        }}
                    />
                </Form.Item>
                {showEnterpriseFilter && (
                    <Form.Item style={{ marginBottom: 12 }}>
                        <Input
                            placeholder="所属企业"
                            style={{ width: 180 }}
                            value={filterEnterprise}
                            onChange={(e) => setFilterState(s => ({ ...s, filterEnterprise: e.target.value }))}
                            allowClear
                        />
                    </Form.Item>
                )}
                <Form.Item style={{ marginBottom: 12 }}>
                    <Input
                        placeholder="操作人"
                        style={{ width: 160 }}
                        value={filterOperator}
                        onChange={(e) => setFilterState(s => ({ ...s, filterOperator: e.target.value }))}
                        allowClear
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="操作类型"
                        style={{ width: 180 }}
                        value={filterOpType}
                        onChange={(v) => setFilterState(s => ({ ...s, filterOpType: v }))}
                        options={Object.keys(OP_TYPE_COLORS).map(t => ({ label: t, value: t }))}
                        maxTagCount={2}
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                    <RangePicker
                        value={filterDateRange}
                        onChange={(v) => setFilterState(s => ({ ...s, filterDateRange: v }))}
                        style={{ width: 240 }}
                        placeholder={['开始日期', '结束日期']}
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                    <Input
                        placeholder="操作对象"
                        style={{ width: 180 }}
                        value={filterKeyword}
                        onChange={(e) => setFilterState(s => ({ ...s, filterKeyword: e.target.value }))}
                        allowClear
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
                        <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Card>
    );
};

// ══════════════════════════════════════════════
//  子组件：日志列表表格
// ══════════════════════════════════════════════

const LogTable = ({ dataSource, loading, showEnterpriseCol, onViewDetail }) => {
    const columns = [
        { title: '操作时间', dataIndex: 'time', key: 'time', width: 170 },
        { title: '操作人', key: 'operator', width: 140, render: (_, r) => <div><div style={{ fontWeight: 500 }}>{r.operatorName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.operatorAccount}</Text></div> },
        { title: 'IP 地址', dataIndex: 'ip', key: 'ip', width: 130, render: (t) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{t}</Text> },
        ...(showEnterpriseCol ? [{
            title: '所属企业', key: 'enterprise', width: 160,
            render: (_, r) => r.enterpriseName
                ? <div><div style={{ fontWeight: 500 }}>{r.enterpriseName}</div><Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.enterpriseId}</Text></div>
                : <Tag style={{ border: 'none', color: '#999', background: '#f5f5f5' }}>平台</Tag>
        }] : []),
        { title: '操作模块', dataIndex: 'module', key: 'module', width: 150 },
        { title: '操作类型', dataIndex: 'opType', key: 'opType', width: 100, render: (v) => <Tag color={OP_TYPE_COLORS[v] || 'default'} style={{ border: 'none' }}>{v}</Tag> },
        { title: '操作对象', key: 'target', width: 180, render: (_, r) => { const parts = (r.target || '').split('\n'); return <div><div style={{ fontWeight: 500 }}>{parts[0]}</div>{parts[1] && <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{parts[1]}</Text>}</div>; } },
        { title: '操作摘要', dataIndex: 'summary', key: 'summary', width: 240, ellipsis: { showTitle: false }, render: (t) => <Text ellipsis={{ tooltip: t }}>{t}</Text> },
        { title: '操作', key: 'action', width: 90, fixed: 'right', render: (_, r) => <Button type="link" size="small" onClick={() => onViewDetail(r)}>查看详情</Button> },
    ];

    const scrollX = showEnterpriseCol ? 1400 : 1200;

    return (
        <Table
            dataSource={dataSource}
            columns={columns}
            rowKey="key"
            bordered={false}
            size="middle"
            loading={loading}
            pagination={{
                showSizeChanger: true,
                showTotal: (total) => `共 ${total} 条记录`,
                defaultPageSize: 10,
                pageSizeOptions: ['20', '50', '100'],
            }}
            scroll={{ x: scrollX }}
            locale={{ emptyText: <Empty description="暂无符合条件的操作日志" /> }}
        />
    );
};

// ══════════════════════════════════════════════
//  子组件：操作详情抽屉
// ══════════════════════════════════════════════

const LogDetailDrawer = ({ visible, record, showEnterpriseInfo, onClose }) => {
    if (!record) return null;

    const renderDetailChanges = (detail) => {
        if (!detail) return <Text type="secondary">本次操作无字段变更记录</Text>;

        const allKeys = new Set([
            ...(detail.before ? Object.keys(detail.before) : []),
            ...(detail.after ? Object.keys(detail.after) : [])
        ]);

        if (allKeys.size === 0) return <Text type="secondary">本次操作无字段变更记录</Text>;

        const changes = [];
        allKeys.forEach(key => {
            const beforeVal = detail.before ? detail.before[key] : null;
            const afterVal = detail.after ? detail.after[key] : null;
            const beforeStr = beforeVal !== null && beforeVal !== undefined
                ? (Array.isArray(beforeVal) ? beforeVal.join('、') : String(beforeVal))
                : '（无）';
            const afterStr = afterVal !== null && afterVal !== undefined
                ? (Array.isArray(afterVal) ? afterVal.join('、') : String(afterVal))
                : '（已删除）';
            const label = LABEL_MAP[key] || key;
            changes.push({ key, label, before: beforeStr, after: afterStr });
        });

        return (
            <div>
                {changes.map((c) => (
                    <div key={c.key} style={{ marginBottom: 12, padding: '8px 12px', background: '#fafafa', borderRadius: 6, borderLeft: '3px solid #1890ff' }}>
                        <Text strong style={{ fontSize: 13 }}>{c.label}</Text>
                        <div style={{ marginTop: 4, display: 'flex', gap: 16 }}>
                            <div style={{ flex: 1 }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>变更前</Text>
                                <div style={{ textDecoration: 'line-through', color: '#ff4d4f', fontSize: 13 }}>{c.before}</div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>变更后</Text>
                                <div style={{ color: '#52c41a', fontSize: 13, fontWeight: 500 }}>{c.after}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Drawer title="操作详情" open={visible} onClose={onClose} width={640} destroyOnClose>
            <Descriptions bordered column={2} size="small" style={{ marginBottom: 24 }}>
                <Descriptions.Item label="操作时间">{record.time}</Descriptions.Item>
                <Descriptions.Item label="操作人">{record.operatorName}（{record.operatorAccount}）</Descriptions.Item>
                <Descriptions.Item label="IP 地址">{record.ip}</Descriptions.Item>
                <Descriptions.Item label="操作类型">
                    <Tag color={OP_TYPE_COLORS[record.opType] || 'default'} style={{ border: 'none' }}>{record.opType}</Tag>
                </Descriptions.Item>
                {showEnterpriseInfo && (
                    <Descriptions.Item label="所属企业" span={2}>
                        {record.enterpriseName ? `${record.enterpriseName}（${record.enterpriseId}）` : '平台'}
                    </Descriptions.Item>
                )}
                <Descriptions.Item label="操作模块" span={2}>{record.module}</Descriptions.Item>
                <Descriptions.Item label="操作对象" span={2}>{(() => { const parts = (record.target || '').split('\n'); return parts.length > 1 ? `${parts[0]}（${parts[1]}）` : record.target; })()}</Descriptions.Item>
            </Descriptions>

            <Title level={5} style={{ marginBottom: 12 }}>操作摘要</Title>
            <div style={{ padding: '10px 14px', background: '#fafafa', borderRadius: 8, marginBottom: 24, lineHeight: 1.8 }}>
                {record.summary}
            </div>

            <Title level={5} style={{ marginBottom: 12 }}>变更详情</Title>
            {renderDetailChanges(record.detail)}
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  子组件：企业日志 Tab — 企业列表
// ══════════════════════════════════════════════

const EnterpriseListView = ({ onViewEnterprise, enterpriseList }) => {
    const dataSource = enterpriseList;
    const [filtered, setFiltered] = useState(enterpriseList);
    const [searchType, setSearchType] = useState('enterpriseName');
    const [searchName, setSearchName] = useState(undefined);
    const [searchId, setSearchId] = useState('');
    const tableRef = useRef(null);

    // 修复日志条数列排序图标居右问题：改为紧随文字
    useEffect(() => {
        const timer = setTimeout(() => {
            const sorter = tableRef.current?.querySelector?.('.ant-table-column-sorters');
            if (sorter) {
                sorter.style.justifyContent = 'flex-start';
                sorter.style.gap = '4px';
            }
        }, 50);
        return () => clearTimeout(timer);
    }, [filtered]);

    const handleSearch = () => {
        let result = [...dataSource];
        if (searchType === 'enterpriseName' && searchName) {
            result = result.filter(e => e.enterpriseName === searchName);
        } else if (searchType === 'enterpriseId' && searchId) {
            const kw = searchId.toLowerCase();
            result = result.filter(e => e.enterpriseId.toLowerCase().includes(kw));
        }
        setFiltered(result);
    };

    const handleReset = () => {
        setSearchName(undefined);
        setSearchId('');
        setFiltered([...dataSource]);
    };

    const columns = [
        { title: '企业名称', dataIndex: 'enterpriseName', key: 'enterpriseName', render: (t) => <span style={{ fontWeight: 500 }}>{t}</span> },
        { title: '企业 ID', dataIndex: 'enterpriseId', key: 'enterpriseId', render: (t) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{t}</Text> },
        { title: '日志条数', dataIndex: 'logCount', key: 'logCount', sorter: (a, b) => a.logCount - b.logCount, render: (t) => <Text strong style={{ fontSize: 15 }}>{t.toLocaleString()}</Text> },
        { title: '操作', key: 'action', width: 100, render: (_, r) => <Button type="link" onClick={() => onViewEnterprise(r)}>查看日志</Button> },
    ];

    return (
        <>
            <Card bordered={false} style={{ marginBottom: 12, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Form layout="inline">
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Input.Group compact>
                            <Select
                                value={searchType}
                                onChange={(v) => { setSearchType(v); setSearchName(undefined); setSearchId(''); }}
                                style={{ width: 100 }}
                            >
                                <Select.Option value="enterpriseName">企业名称</Select.Option>
                                <Select.Option value="enterpriseId">企业ID</Select.Option>
                            </Select>
                            {searchType === 'enterpriseName' ? (
                                <Select
                                    showSearch
                                    placeholder="请选择企业名称"
                                    allowClear
                                    style={{ width: 220 }}
                                    value={searchName}
                                    onChange={setSearchName}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {dataSource.map(item => (
                                        <Select.Option key={item.enterpriseId} value={item.enterpriseName}>
                                            {item.enterpriseName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            ) : (
                                <Input
                                    placeholder="请输入企业ID"
                                    allowClear
                                    style={{ width: 220 }}
                                    value={searchId}
                                    onChange={(e) => setSearchId(e.target.value)}
                                />
                            )}
                        </Input.Group>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} ref={tableRef}>
                <Table
                    dataSource={filtered}
                    columns={columns}
                    rowKey="key"
                    bordered={false}
                    size="middle"
                    pagination={{
                        showSizeChanger: true,
                        showTotal: (total) => `共 ${total} 个企业`,
                        defaultPageSize: 10,
                        pageSizeOptions: ['20', '50', '100'],
                    }}
                    locale={{ emptyText: <Empty description="暂无企业数据" /> }}
                />
            </Card>
        </>
    );
};

// ══════════════════════════════════════════════
//  子组件：企业日志明细页
// ══════════════════════════════════════════════

const EnterpriseDetail = ({ selectedEnterprise, onBack, onViewDetail }) => {
    const enterpriseData = [
        ...getExtraEnterpriseLogs().filter(e => e.enterpriseId === selectedEnterprise.enterpriseId),
        ...MOCK_ENTERPRISE_LOGS.filter(e => e.enterpriseId === selectedEnterprise.enterpriseId),
    ];

    const [detailData] = useState(enterpriseData);
    const [detailFiltered, setDetailFiltered] = useState(enterpriseData);
    const [detailLoading, setDetailLoading] = useState(false);
    const [detailFilter, setDetailFilter] = useState({
        filterModule: [], filterOperator: '', filterOpType: [], filterDateRange: null, filterKeyword: '',
    });

    const handleDetailSearch = () => {
        setDetailLoading(true);
        setTimeout(() => {
            let result = [...detailData];
            const { filterModule, filterOperator, filterOpType, filterDateRange, filterKeyword } = detailFilter;
            if (filterModule.length > 0) result = result.filter(item => filterModule.some(path => { const last = path[path.length - 1]; return path.length === 1 ? (item.module.startsWith(last + ' >') || item.module === last) : item.module === last; }));
            if (filterOperator) {
                const kw = filterOperator.toLowerCase();
                result = result.filter(item => item.operatorName.toLowerCase().includes(kw) || item.operatorAccount.toLowerCase().includes(kw));
            }
            if (filterOpType.length > 0) result = result.filter(item => filterOpType.includes(item.opType));
            if (filterDateRange && filterDateRange[0] && filterDateRange[1]) {
                const start = filterDateRange[0].startOf('day');
                const end = filterDateRange[1].endOf('day');
                result = result.filter(item => { const t = new Date(item.time); return t >= start && t <= end; });
            }
            if (filterKeyword) {
                const kw = filterKeyword.toLowerCase();
                result = result.filter(item => (item.target && item.target.toLowerCase().includes(kw)) || (item.summary && item.summary.toLowerCase().includes(kw)));
            }

            setDetailFiltered(result);
            setDetailLoading(false);
        }, 300);
    };

    const handleDetailReset = () => {
        setDetailFilter({ filterModule: [], filterOperator: '', filterOpType: [], filterDateRange: null, filterKeyword: '' });
        setDetailFiltered([...detailData]);
    };

    return (
        <>
            <div style={{ marginBottom: 16 }}>
                <Button icon={<ArrowLeftOutlined />} type="link" onClick={onBack} style={{ padding: 0, marginBottom: 8 }}>
                    返回企业列表
                </Button>
                <Title level={4} style={{ margin: 0 }}>
                    {selectedEnterprise.enterpriseName}（{selectedEnterprise.enterpriseId}）操作日志
                </Title>
            </div>
            <LogFilter
                filterState={detailFilter}
                setFilterState={setDetailFilter}
                onSearch={handleDetailSearch}
                onReset={handleDetailReset}
                showEnterpriseFilter={false}
            />
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <LogTable
                    dataSource={detailFiltered}
                    loading={detailLoading}
                    showEnterpriseCol={true}
                    onViewDetail={onViewDetail}
                />
            </Card>
        </>
    );
};

// ══════════════════════════════════════════════
//  主组件
// ══════════════════════════════════════════════

const AuditLog = () => {
    const location = useLocation();
    const isPlatformLog = location.pathname === '/audit-log/platform';

    // 平台日志 — Tab 状态
    const [platformTab, setPlatformTab] = useState('platform');

    // 企业日志明细（平台视角下钻）
    const [selectedEnterprise, setSelectedEnterprise] = useState(null);

    // 列表数据（内置种子 + 运行时新增）
    const platformLogData = isPlatformLog
        ? [...getExtraPlatformLogs(), ...MOCK_PLATFORM_LOGS]
        : [...getExtraEnterpriseLogs(), ...MOCK_ENTERPRISE_LOGS];

    const [dataSource] = useState(platformLogData);
    const [filteredData, setFilteredData] = useState(platformLogData);
    const [loading, setLoading] = useState(false);

    // 详情抽屉
    const [detailVisible, setDetailVisible] = useState(false);
    const [detailRecord, setDetailRecord] = useState(null);

    // 筛选状态
    const [filterState, setFilterState] = useState({
        filterModule: [], filterOperator: '', filterOpType: [],
        filterDateRange: null, filterKeyword: '', filterEnterprise: '',
    });

    // 筛选逻辑
    const handleSearch = () => {
        setLoading(true);
        setTimeout(() => {
            let result = [...dataSource];
            const { filterModule, filterOperator, filterOpType, filterDateRange, filterKeyword, filterEnterprise } = filterState;

            if (filterModule.length > 0) result = result.filter(item => filterModule.some(path => { const last = path[path.length - 1]; return path.length === 1 ? (item.module.startsWith(last + ' >') || item.module === last) : item.module === last; }));
            if (filterOperator) {
                const kw = filterOperator.toLowerCase();
                result = result.filter(item => item.operatorName.toLowerCase().includes(kw) || item.operatorAccount.toLowerCase().includes(kw));
            }
            if (filterOpType.length > 0) result = result.filter(item => filterOpType.includes(item.opType));
            if (filterDateRange && filterDateRange[0] && filterDateRange[1]) {
                const start = filterDateRange[0].startOf('day');
                const end = filterDateRange[1].endOf('day');
                result = result.filter(item => { const t = new Date(item.time); return t >= start && t <= end; });
            }
            if (filterKeyword) {
                const kw = filterKeyword.toLowerCase();
                result = result.filter(item => (item.target && item.target.toLowerCase().includes(kw)) || (item.summary && item.summary.toLowerCase().includes(kw)));
            }
            if (filterEnterprise) {
                const kw = filterEnterprise.toLowerCase();
                result = result.filter(item => (item.enterpriseName && item.enterpriseName.toLowerCase().includes(kw)) || (item.enterpriseId && item.enterpriseId.toLowerCase().includes(kw)));
            }

            setFilteredData(result);
            setLoading(false);
        }, 300);
    };

    const handleReset = () => {
        setFilterState({ filterModule: [], filterOperator: '', filterOpType: [], filterDateRange: null, filterKeyword: '', filterEnterprise: '' });
        setFilteredData([...dataSource]);
    };

    const showDetail = (record) => { setDetailRecord(record); setDetailVisible(true); };

    // 企业列表（内置 + 运行时新增日志涉及的企业）
    const buildEnterpriseList = () => {
        const list = MOCK_ENTERPRISE_LIST.map((e) => ({ ...e }));
        const byId = new Map(list.map((e) => [e.enterpriseId, e]));
        getExtraEnterpriseLogs().forEach((l) => {
            if (!l.enterpriseId) return;
            if (!byId.has(l.enterpriseId)) {
                const item = { key: l.enterpriseId, enterpriseName: l.enterpriseName, enterpriseId: l.enterpriseId, logCount: 0 };
                byId.set(l.enterpriseId, item);
                list.push(item);
            }
            byId.get(l.enterpriseId).logCount += 1;
        });
        return list;
    };

    // 查看企业日志明细
    const handleViewEnterprise = (enterprise) => {
        setSelectedEnterprise(enterprise);
    };

    const handleBackToEnterpriseList = () => {
        setSelectedEnterprise(null);
    };

    // 渲染企业日志明细
    const renderEnterpriseDetail = () => (
        <EnterpriseDetail
            key={selectedEnterprise.enterpriseId}
            selectedEnterprise={selectedEnterprise}
            onBack={handleBackToEnterpriseList}
            onViewDetail={showDetail}
        />
    );

    // ═══ 企业侧页面 ═══
    if (!isPlatformLog) {
        return (
            <div style={{ padding: 24 }}>
                <div style={{ marginBottom: 16 }}>
                    <Title level={4}>操作日志</Title>
                </div>
                <LogFilter
                    filterState={filterState}
                    setFilterState={setFilterState}
                    onSearch={handleSearch}
                    onReset={handleReset}
                    showEnterpriseFilter={false}
                />
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                    <LogTable
                        dataSource={filteredData}
                        loading={loading}
                        showEnterpriseCol={false}
                        onViewDetail={showDetail}
                    />
                </Card>
                <LogDetailDrawer
                    visible={detailVisible}
                    record={detailRecord}
                    showEnterpriseInfo={false}
                    onClose={() => setDetailVisible(false)}
                />
            </div>
        );
    }

    // ═══ 平台侧页面 ═══
    // 如果正在查看某个企业的日志明细
    if (selectedEnterprise) {
        return (
            <div style={{ padding: 24 }}>
                {renderEnterpriseDetail()}
                <LogDetailDrawer
                    visible={detailVisible}
                    record={detailRecord}
                    showEnterpriseInfo={true}
                    onClose={() => setDetailVisible(false)}
                />
            </div>
        );
    }

    // 平台日志 Tab 页
    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16 }}>
                <Title level={4}>平台日志</Title>
            </div>
            <Tabs
                activeKey={platformTab}
                onChange={setPlatformTab}
                items={[
                    {
                        key: 'platform',
                        label: '平台日志',
                        children: (
                            <>
                                <LogFilter
                                    filterState={filterState}
                                    setFilterState={setFilterState}
                                    onSearch={handleSearch}
                                    onReset={handleReset}
                                    showEnterpriseFilter={false}
                                />
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                                    <LogTable
                                        dataSource={filteredData}
                                        loading={loading}
                                        showEnterpriseCol={false}
                                        onViewDetail={showDetail}
                                    />
                                </Card>
                            </>
                        ),
                    },
                    {
                        key: 'enterprise',
                        label: '企业日志',
                        children: <EnterpriseListView enterpriseList={buildEnterpriseList()} onViewEnterprise={handleViewEnterprise} />,
                    },
                ]}
            />
            <LogDetailDrawer
                visible={detailVisible}
                record={detailRecord}
                showEnterpriseInfo={platformTab === 'platform' ? false : true}
                onClose={() => setDetailVisible(false)}
            />
        </div>
    );
};

export default AuditLog;
